import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes/Routes';
import 'bulma/css/bulma.min.css';
import CookieBanner from './components/CookieBanner';
import GoogleAnalytics from './components/GoogleAnalytics';

const App = () => {
  return (
    <Router>
      <CookieBanner />
      <GoogleAnalytics />
      <Routes />
    </Router>
  );
};

export default App;